export default __webpack_public_path__ + "static/media/s1.37ae9d1c.jpg";